import { InjectionToken } from '@angular/core';

import type { DoodOpenCheck } from '@core/models/check.model';

/** Runtime VM emitted by `ChecksPageBlock` data sources. */
export type ChecksPageBlockViewModel = {
  checks: readonly DoodOpenCheck[];
  isChecksLoading: boolean;
};

export const CHECKS_PAGE_BLOCK_LOADING_VM: ChecksPageBlockViewModel = {
  checks: [],
  isChecksLoading: true,
};

export const CHECKS_PAGE_BLOCK_EMPTY_VM: ChecksPageBlockViewModel = {
  checks: [],
  isChecksLoading: false,
};

export interface ChecksPageBlockDataSource {
  readonly vm$: import('rxjs').Observable<ChecksPageBlockViewModel>;
}

export const CHECKS_PAGE_BLOCK_DATA_SOURCE = new InjectionToken<ChecksPageBlockDataSource>(
  'CHECKS_PAGE_BLOCK_DATA_SOURCE',
);
